import { createContext, FC, memo, PropsWithChildren, useContext } from 'react';

import { ImageTypeLoaderProps } from '../types/imageTypeLoader';

const defaults: ImageTypeMetadataContextProps = {
	getOrLoadImageType: () => undefined,
	loaders: {},
	isUncropped: false,
};

const ImageTypeMetadataContext = createContext<ImageTypeMetadataContextProps>(defaults);

export interface ImageTypeMetadataContextProps extends ImageTypeLoaderProps {
	isUncropped: boolean;
}

const ImageTypeMetadataProvider: FC<PropsWithChildren<{ value: ImageTypeMetadataContextProps }>> = ({
	value,
	children,
}) => {
	return <ImageTypeMetadataContext.Provider value={value}>{children}</ImageTypeMetadataContext.Provider>;
};

export const ImageTypeLoadingProvider = memo(ImageTypeMetadataProvider);

// eslint-disable-next-line react-refresh/only-export-components
export const useImageTypeMetadataContext = (): ImageTypeMetadataContextProps => {
	const context = useContext(ImageTypeMetadataContext);
	if (context === undefined) {
		throw new Error('useImageLoadingContext must be used within a ImageLoadingContext');
	}
	return context;
};
